import { render, staticRenderFns } from "./sendDrug.vue?vue&type=template&id=1c9045d0&scoped=true&"
import script from "./sendDrug.vue?vue&type=script&lang=js&"
export * from "./sendDrug.vue?vue&type=script&lang=js&"
import style0 from "./sendDrug.vue?vue&type=style&index=0&id=1c9045d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9045d0",
  null
  
)

export default component.exports